import { Dialog, DialogContent } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { DialogTitleClosable } from "../../components/DialogTitleClosable";
import { iotDeviceEvents } from "../../data/iotDeviceEvents.data";
import { formatDateTime } from "../../utils";
import { IotDeviceEventDto } from "./dtos/IotDeviceEventDto";


const columnDefinitions: GridColDef[ ] = [

    {
        field: 'deviceEuid',
        headerName: 'Device Euid',
        width: 200,
        editable: true,
        headerAlign: 'center',
        align: 'center'
    },

    {
        field: 'deviceName',
        headerName: 'Device Name',
        width: 150,
        editable: true,
        headerAlign: 'center',
        align: 'center'
    },

    {
        field: 'gatewayEuid',
        headerName: 'Gateway Euid',
        width: 200,
        editable: true,
        headerAlign: 'center',
        align: 'center'
    },

    {
        field: 'lastSeenDateTime',
        headerName: 'Last Seen',
        width: 200,
        editable: true,
        headerAlign: 'center',
        align: 'center',
        renderCell: ( params => formatDateTime( params.row.lastSeenDateTime ))
    },

    {
        field: 'lqi',
        headerName: 'LQI',
        width: 100,
        editable: true,
        headerAlign: 'center',
        align: 'center'
    },

    {
        field: 'networkMac',
        headerName: 'Network Mac',
        width: 200,
        editable: true,
        headerAlign: 'center',
        align: 'center'
    },

    {
        field: 'rssi',
        headerName: 'RSSI',
        width: 100,
        editable: true,
        headerAlign: 'center',
        align: 'center'
    },

    {
        field: 'status',
        headerName: 'Status',
        width: 150,
        editable: true,
        headerAlign: 'center',
        align: 'center'
    },

];


type DataRow = {

    id: string;
    deviceEuid: string;
    deviceName: string;
    gatewayEuid: string;
    lastSeenDateTime: Date;
    lqi: number;
    networkMac: string;
    rssi: string;
    status: string;

};


const dialogSx = {

    '.MuiPaper-root': { 
        maxWidth: 'fit-content'
    }

};


type IotDeviceEventsProps = {

    displayIotDeviceEvents: boolean;
    deviceName: string;
    iotDeviceEventDtos: IotDeviceEventDto[];
    onClose(): void;

};


export const IotDeviceEvents: React.FC<IotDeviceEventsProps> = ( props: IotDeviceEventsProps ) => {

    const { displayIotDeviceEvents, deviceName, iotDeviceEventDtos, onClose } = props; 

    const [ columns, setColumns ] = useState< GridColDef[ ] >( columnDefinitions );
    const [ open, setOpen ] = useState<boolean>( false );
    const [ pageSize, setPageSize ] = useState<number>( 10 );
    const [ rows, setRows ] = useState<DataRow[]>( [] );


    useEffect( () => {

        if( !displayIotDeviceEvents ) {

            return;

        }

        setOpen( true );

        const rows: DataRow[] = [];

        let index = 0;
        
        for( const iotDeviceEventDto of iotDeviceEventDtos ) {

            const iotDeviceStatus = iotDeviceEvents.find( be => be.event === iotDeviceEventDto.status );

            if( !iotDeviceStatus ) {
                
                throw Error( `IoT Device status ${iotDeviceEventDto.status} not found` );

            }
            
            rows.push({

                id: index.toString( ),
                deviceEuid: iotDeviceEventDto.deviceEuid,
                deviceName: iotDeviceEventDto.deviceName,
                gatewayEuid: iotDeviceEventDto.gatewayEuid,
                lastSeenDateTime: iotDeviceEventDto.lastSeenDateTime,
                lqi: iotDeviceEventDto.lqi,
                networkMac: iotDeviceEventDto.networkMac,
                rssi: iotDeviceEventDto.rssi,
                status: iotDeviceEventDto.status,

            });

            ++index;

        }

        setRows( rows );

    }, [displayIotDeviceEvents] );


    const handleClose = ( ) => {
        
        
        setOpen( false );
        onClose( );

    }

        
    return(

        <Dialog
            onClose={handleClose}
            open={open}
            sx={dialogSx}
        >
            <DialogTitleClosable onClose={handleClose}>
                Events for {deviceName}
            </DialogTitleClosable>
            
            <DialogContent dividers>

                <DataGrid
                    rows={rows}
                    columns={columns}
                    disableSelectionOnClick
                    sx={{ width: 1400 }}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[5, 10, 20]}
                    pagination
                    autoHeight={true}
                    initialState={{
                        sorting: {
                          sortModel: [{ field: 'lastSeenDateTime', sort: 'asc' }],
                        }
                    }}
                />

            </DialogContent>
        </Dialog>

    );

};